<template>
    <div id="reports_edit_page" class="container-fluid">
        <form>
            <div class="form-group">
                <label for="report_name">CLIENT NAME</label>
                <p>{{ report.client_name }}</p>
            </div>

            <div class="form-group">
                <label for="report_name">REPORT NAME</label>
                <input v-model="report_name" type="text" class="form-control col-md-5 col-lg-4 col-xl-3" id="report_name">
            </div>

            <div class="form-group">
                <label for="report_name">EXPORT OPTIONS</label>
                <label class="d-block margin-y5">
                    <p-input v-model="report.export_show_header_text" class="p-default p-curve single" type="checkbox"> Show header text</p-input>
                </label>
            </div>

            <div v-if="client_data_connection_accounts.count > 0" class="form-group margin-top20">
                <div class="padding-bottom30">
                    <h5 class="pull-left margin-bottom0">Select your data sources ({{ client_data_connection_accounts.count }})</h5>

                    <div class="pull-right">
                        <input v-model="client_data_connection_accounts_filter" type="text" placeholder="Search accounts..." class="form-control search-accounts">
                    </div>
                </div>

                <table class="table table-borderless data-connection-accounts">
                    <tbody>
                        <template v-for="data_connection_accounts in client_data_connection_accounts.data">
                            <template v-if="isFilterMatch(data_connection_account)" v-for="data_connection_account in data_connection_accounts">
                                <tr>
                                    <td class="align-middle">
                                        <img :src="`${$store.state.app_url}images/data_sources/${data_connection_account.abbreviation}.png`">
                                        <span>{{ data_connection_account.name }}</span>
                                    </td>
                                    <td class="align-middle">
                                        <span>{{ data_connection_account.name_given_by_user }}</span>
                                    </td>
                                    <td class="align-middle">
                                        <span>{{ data_connection_account.primary_name_in_source }} ({{ data_connection_account.primary_account_id }})</span>
                                    </td>
                                    <td class="align-middle text-right">
                                        <button @click="connectOrDisconnect(data_connection_account.id)" type="button" class="btn reverse" :class="selected_accounts.indexOf(data_connection_account.id) > -1 ? 'btn-danger' : 'btn-info'">
                                            {{ selected_accounts.indexOf(data_connection_account.id) > -1 ? 'Disconnect' : 'Connect' }}
                                        </button>
                                    </td>
                                </tr>
                            </template>
                        </template>
                    </tbody>
                </table>
            </div>

            <div class="form-group text-center margin-top15">
                <button :disabled="save_disabled" id="save_report" data-loading-text='<span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>SAVING...' @click="saveReport" type="button" class="btn btn-info btn-lg">SAVE CHANGES</button>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        created() {
            this.fetchServerData();
        },

        updated() {
            this.validateForm();
        },

        data() {
            return {
                report:                                 {},
                clients:                                [],
                report_name:                            '',
                client_data_connection_accounts_filter: '',
                client_data_connection_accounts:        {},
                selected_accounts:                      [],
                save_disabled:                          true
            }
        },

        methods: {
            fetchServerData() {
                axios.all([
                    axios.get(`/api/reports/${this.$route.params.id}`),
                    axios.get(`/api/data-connections/reports/${this.$route.params.id}`)
                ])
                .then(axios.spread((report, reportDataConnectionAccounts) => {
                    this.report                          = report.data;
                    this.client_data_connection_accounts = reportDataConnectionAccounts.data;
                    this.report_name                     = report.data.name;

                    if (reportDataConnectionAccounts.data.count > 0) {
                        _.each(reportDataConnectionAccounts.data.data, accounts => {
                            _.each(accounts, account => {
                                if (account.report_id !== null) {
                                    this.selected_accounts.push(account.id);
                                }
                            });
                        });
                    }
                }));
            },

            connectOrDisconnect(accountId) {
                const index = this.selected_accounts.indexOf(accountId);

                if (index === -1) {
                    this.selected_accounts.push(accountId);
                } else {
                    this.selected_accounts.splice(index, 1);
                }
            },

            isFilterMatch(dataConnectionAccount) {
                if (!this.client_data_connection_accounts_filter.trim()) {
                    return true;
                }

                const regexp = new RegExp(`.*${this.client_data_connection_accounts_filter}.*`, 'i');

                return !!(dataConnectionAccount.primary_account_id.toString().match(regexp) || dataConnectionAccount.primary_name_in_source.match(regexp));
            },

            validateForm() {
                this.save_disabled = !(this.report_name && this.selected_accounts.length);
            },

            saveReport() {
                $('#save_report').button('loading');

                let formData = new FormData;
                formData.append('report_name', this.report_name);
                formData.append('export_show_header_text', this.report.export_show_header_text);
                formData.append('selected_accounts', JSON.stringify(this.selected_accounts));
                formData.append('_method', 'PUT');

                this.ajaxSubmit({'Content-Type': 'multipart/form-data'}, 'POST', `/api/reports/${this.$route.params.id}`, formData).then(response => {
                    $('#save_report').button('reset');

                    this.$notify({
                        type: 'success',
                        text: this.messages.REPORT_UPDATED
                    });

                    this.$router.push({path: '/reports'});
                });
            }
        }
    }
</script>

<style lang="scss">
    @import '~@/_variables.scss';

    #reports_edit_page {
        .search-accounts {
            width: 20vw;
        }
        .data-connection-accounts {
            font-size: 1.2rem;
            td:first-child {
                font-weight: 500;
            }
            img {
                width: 3.2rem;
            }
        }

        .pretty.p-default input:checked ~ .state label::after {
            background-color: $info !important;
        }

        .pretty.p-switch input:checked ~ .state label::after {
            background-color: $info !important;
        }
    }
</style>
